import React from 'react'
import { detectNearBreak, type NearBreakInfo } from '../utils/nearBreak'

export default function NearBreakCard({ data, exampleWhenEmpty = false }: { data: any; exampleWhenEmpty?: boolean }) {
  const cf = (data as any)?.confluence_factors || (data as any)?.confluence || {}
  const trend = String((data as any)?.target_trend ?? '').toLowerCase()
  const info = detectNearBreak(cf, trend)

  const thrCritical = 0.05 // %
  const isCritical = !!info && (
    (info.targetPct != null && info.targetPct <= thrCritical) ||
    (info.parentPct != null && info.parentPct <= thrCritical)
  )

  if (!isCritical && !exampleWhenEmpty) return null

  const lines = info ? formatLines(info) : [
    'Alvo: possível rompimento por cima',
    'Proximidade do alvo: 0.45%'
  ]

  return (
    <div className="rounded-xl border border-red-500/40 bg-red-500 text-red-50 px-4 py-3 shadow-[0_12px_28px_-8px_rgba(239,68,68,0.55),0_0_0_1px_rgba(0,0,0,0.06)]">
      <div className="text-base font-semibold">{'Aten\u00E7\u00E3o: proximidade de rompimento'}</div>
      <div className="mt-1 space-y-1 text-sm/relaxed">
        {lines.map((l, i) => (
          <div key={i} className="leading-tight">{l}</div>
        ))}
      </div>
    </div>
  )

  function formatLines(n: NearBreakInfo): string[] {
    const out: string[] = []
    if (n.target) {
      out.push(`Alvo: possível rompimento por ${n.target === 'up' ? 'cima' : 'baixo'}`)
      if (n.targetPct !== null) out.push(`Proximidade do alvo: ${n.targetPct.toFixed(2)}%`)
    }
    if (n.parent) {
      out.push(`Timeframe pai: possível rompimento por ${n.parent === 'up' ? 'cima' : 'baixo'}`)
      if (n.parentPct !== null) out.push(`Proximidade do pai: ${n.parentPct.toFixed(2)}%`)
    }
    return out
  }
}

